import { __assign, __rest } from "tslib";
import React, { useRef } from 'react';
import { cn } from '@bem-react/classname';
import { usePreventScroll } from '../usePreventScroll';
import { useFocusTrap } from '../useFocusTrap';
import { useOverlay } from '../useOverlay';
import { Portal } from '../Portal';
import './Modal.css';
export var cnModal = cn('Modal');
/**
 * Используется для создания всплывающих модальных окон.
 * @param {IModalProps} props
 */
export var Modal = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.contentVerticalAlign, align = _b === void 0 ? 'middle' : _b, _c = _a.hasAnimation, hasAnimation = _c === void 0 ? true : _c, innerRef = _a.innerRef, keepMounted = _a.keepMounted, onClose = _a.onClose, _d = _a.preventBodyScroll, preventBodyScroll = _d === void 0 ? true : _d, scope = _a.scope, visible = _a.visible, zIndex = _a.zIndex, _e = _a.trapFocus, trapFocus = _e === void 0 ? true : _e, _f = _a.autoFocus, autoFocus = _f === void 0 ? true : _f, _g = _a.restoreFocus, restoreFocus = _g === void 0 ? true : _g, restoreFocusRef = _a.restoreFocusRef, ariaLabelledBy = _a.ariaLabelledBy, props = __rest(_a, ["children", "className", "contentVerticalAlign", "hasAnimation", "innerRef", "keepMounted", "onClose", "preventBodyScroll", "scope", "visible", "zIndex", "trapFocus", "autoFocus", "restoreFocus", "restoreFocusRef", "ariaLabelledBy"]);
    var contentRef = useRef(null);
    usePreventScroll({ enabled: preventBodyScroll && visible });
    useFocusTrap({
        enabled: trapFocus && visible,
        scopeRef: contentRef,
        autoFocus: autoFocus,
        restoreFocus: restoreFocus,
        restoreFocusRef: restoreFocusRef,
    });
    useOverlay({
        visible: visible,
        onClose: onClose,
        essentialRefs: [contentRef],
        unsafe_strategy: 'pressup',
    });
    return (React.createElement(Portal, { scope: scope, visible: visible, keepMounted: keepMounted },
        React.createElement("div", __assign({}, props, { ref: innerRef, className: cnModal({ visible: visible, hasAnimation: hasAnimation }, [className]), style: { zIndex: zIndex } }),
            React.createElement("div", { className: cnModal('Overlay') }),
            React.createElement("div", { className: cnModal('Wrapper') },
                React.createElement("div", { className: cnModal('Table') },
                    React.createElement("div", { className: cnModal('Cell', { align: align }) },
                        React.createElement("div", { ref: contentRef, className: cnModal('Content'), tabIndex: -1, role: "dialog", "aria-labelledby": ariaLabelledBy, "aria-modal": true }, children)))))));
};
Modal.displayName = cnModal();
